import each from 'lodash/each';
import assign from 'lodash/assign';
import uiRouter from '@uirouter/angularjs';
import ngTranslate from 'angular-translate';

import { VlnDialogControllerModule } from 'components/modals/dialog.controller';
import { SpinnerModule } from 'components/spinner/spinner.module';

import template from './savebar.html';
import modalTemplate from './savebar.modal.html';
import './savebar.scss';

export const SaveBarModule = angular
    .module('app.components.savebar', [
        'ngMaterial',
        uiRouter,
        ngTranslate,
        VlnDialogControllerModule,
        SpinnerModule
    ]).directive('saveBar', (
        $rootScope,
        $translate,
        $state,
        $window,
        $timeout,
        $mdDialog,
        $location) => {
        return {
            restrict: 'E',
            template,
            scope: {
                form: '=vlnForm',
                model: '=vlnModel',
                onReset: '&',
                onSave: '&',
                preferences: '=?',
                labels: '<'
            },
            link: (scope, element, attrs) => {
                var lock = false;

                var STATE = {
                    error: 0,
                    default: 1,
                    loading: 2,
                    success: 3
                };

                var vm = {
                    state: STATE.default,
                    save: save,
                    cancel: cancel,
                    isDetail: attrs.isDetail !== 'false',
                    disableAdd: attrs.disableAdd === 'true'
                };

                var currentState;

                init();

                function init() {
                    scope.vm = vm;
                    scope.STATE = STATE;
                    scope.preferences = scope.preferences || {};
                    scope.preferences.force = false;
                    scope.preferences.muffle = false;
                    scope.labels = assign({
                        loading: 'SAVEBAR.LOADING',
                        error: 'BUTTON.ERROR',
                        success: 'BUTTON.SUCCESS',
                        default: 'BUTTON.SAVE'
                    }, scope.labels);

                    registerUnloadListeners();
                    registerPreferenceListeners();

                    if (attrs.vlnModel) {
                        registerModelListeners();
                    }

                    var doIpadHack = ($window.navigator.platform === 'iPhone')
                        || ($window.navigator.platform === 'iPad');

                    if (doIpadHack) {
                        element.css('transform', 'translate3d(0,0,0)');
                    }
                    currentState = $state.current.name;
                }

                function manageVisible(show) {
                    if (lock) return;

                    show = show || false;
                    if (scope.preferences.muffle) {
                        show = false;
                    } else if (scope.preferences.force) {
                        show = true;
                    }

                    toggleSavebar(show);
                }

                function hasChanged(model) {
                    if (!model) return false;

                    var hasChanges = false;
                    if (Array.isArray(model)) {
                        each(model, (item) => {
                            if (item.hasChanges && item.hasChanges()) {
                                hasChanges = true;
                            }
                        });
                    } else if (model.hasChanges()) {
                        hasChanges = true;
                    }

                    return hasChanges;
                }

                function toggleSavebar(show) {
                    if (lock) return;

                    show = show || false;

                    element.find('.save-bar').toggleClass('show', show);
                    angular.element('body').toggleClass('savebar-active', show);
                }

                function isAddPage() {
                    return /add/g.test($location.path());
                }

                function isAddOrList(saveType) {
                    if (((saveType === 'list' || saveType === 'add') && !isAddPage()) ||
                        (saveType === 'list' && isAddPage())) {
                        return true;
                    }
                }

                function isAdd(saveType) {
                    if (saveType === 'add' && isAddPage()) {
                        return true;
                    }
                }

                function save(saveType) {
                    if (!scope.onSave) {
                        throw new Error(`No Save function declared in ${currentState}`);
                    }

                    if (['list', 'add', 'stay'].indexOf(saveType) === -1) {
                        saveType = scope.preferences.defaultAction;
                    }

                    if (vm.state === STATE.loading) return;

                    vm.state = STATE.loading;

                    pushGTMChanges('save', saveType);

                    scope.onSave().then(
                        () => {
                            //Success
                            toggleSavebar(true);
                            lock = true;
                            vm.state = STATE.success;

                            $timeout(() => {
                                clearPreferences();
                                $rootScope.$broadcast('saveBarSave');
                                if (isAddOrList(saveType)) {
                                    $window.dataLayer.push({
                                        event: `admin_${currentState}_saveAndGoTo-${saveType}`
                                    });
                                    $state.go(`${currentState.split('.')[0]}.${saveType}`);
                                } else if (isAdd(saveType)) {
                                    $window.dataLayer.push({
                                        event: `admin_${currentState}_saveAndAdd`
                                    });
                                    $state.reload();
                                } else if (saveType === 'stay') {
                                    $window.dataLayer.push({
                                        event: `admin_${currentState}_saveAndStay`
                                    });
                                }
                            });
                        },
                        () => {
                            //Failure
                            toggleSavebar(true);
                            lock = true;
                            vm.state = STATE.error;

                            $timeout(() => {
                                vm.state = STATE.default;
                            });
                        }
                    );
                }

                function cancel() {
                    pushGTMChanges('cancel', false);
                    if (scope.model) {
                        if (Array.isArray(scope.model)) {
                            for (let i = 0; i < scope.model.length; i += 1) {
                                if (scope.model[i].hasChanges()) {
                                    scope.model[i].reset();
                                }
                            }
                        } else if (scope.model.hasChanges()) {
                            scope.model.reset();
                        }
                    }

                    if (scope.form) {
                        scope.form.$setUntouched();
                    }

                    if (scope.onReset) {
                        scope.onReset();
                    }

                    $rootScope.$broadcast('saveBarCancel');
                }

                function pushGTMChanges(type, saveType) {
                    if (!saveType) {
                        if (scope.model && scope.model.changedValues) {
                            scope.model.changedValues.forEach((el) => {
                                $window.dataLayer.push({
                                    event: `admin_${currentState}_${type}-changedVal-${el}`
                                });
                            });
                        } else {
                            $window.dataLayer.push({
                                event: `admin_${currentState}-${type}`
                            });
                        }
                    }
                }

                function registerPreferenceListeners() {
                    scope.$watch('preferences', () => {
                        if (scope.model) {
                            manageVisible(hasChanged(scope.model));
                        } else {
                            manageVisible();
                        }
                    }, true);
                }

                function registerModelListeners() {
                    scope.$watch(() => scope.model, () => {
                        if (scope.model) {
                            manageVisible(hasChanged(scope.model));
                        }
                    }, true);
                }

                function onPageChange(event, newUrl, newState) {
                    if (hasChanged(scope.model) || scope.preferences.force) {
                        event.preventDefault();

                        // transitionTo() promise will be rejected with
                        // a 'transition prevented' error
                        var saveModal = $mdDialog.show({
                            clickOutsideToClose: true,
                            scope: scope,
                            preserveScope: true,
                            controller: 'vlnDialogController',
                            template: modalTemplate,
                            theme: ''
                        });

                        saveModal.then(() => {
                            //yes, navigate away
                            vm.cancel();

                            if (event.name === '$locationChangeStart') {
                                const newUrlObject = new URL(newUrl);
                                $location.url(`${newUrlObject.pathname}${newUrlObject.search}`);
                            } else if (event.name === '$stateChangeStart') {
                                $state.go(newState.name).catch(() => {
                                    $state.go(newState.name.replace('.**', '.list'));
                                });
                            }
                        });
                    }
                }

                function registerUnloadListeners() {
                    var stopLocationWatch = $rootScope.$on('$locationChangeStart',
                        (event, newUrl) => onPageChange(event, newUrl));
                    var stopStateWatch = $rootScope.$on('$stateChangeStart',
                        (event, newState) => onPageChange(event, null, newState));

                    $window.onbeforeunload = (event) => {
                        var message;
                        if (hasChanged(scope.model) || scope.preferences.force) {
                            message = $translate.instant('LEAVE.UNSAVEDCHANGES');
                            if (typeof event == 'undefined') {
                                event = $window.event;
                            }

                            if (event) {
                                event.returnValue = message;
                            }

                            return message;
                        }
                    };

                    scope.$on('$destroy', () => {
                        $window.onbeforeunload = undefined;
                        stopStateWatch();
                        stopLocationWatch();
                    });
                }

                function clearPreferences() {
                    scope.preferences.muffle = false;
                    scope.preferences.force = false;
                    lock = false;
                    manageVisible(false);

                    //Hide savebar before changing state back
                    $timeout(() => {
                        vm.state = STATE.default;
                    });
                }
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/savebar/savebar.module.js